// import React from "react";
import exportImg1 from "../assets/Our_Mission.png";
import exportImg2 from "../assets/Our_Vision_Opt1.png";
// import Header from "../components/Header";
import Hero from "../components/Hero";
import founderImg from "../assets/founderImg.jpeg";

export default function AboutUs() {
  return (
    <>
      {<Hero />}

      <main className="bg-[#FBF1EB]">
        {/* WHO WE ARE Section */}
        <section className="py-12 px-4 md:px-12 lg:px-24 bg-[#fff3d6]">
          <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-10 items-start">
            {/* Text */}
            <div>
              <h2 className="bg-[#7B4B3A] text-white inline-block px-4 py-2 rounded-sm mb-4 text-lg font-semibold">
                ABOUT US
              </h2>
              <div className="text-[#34302B] text-lg leading-relaxed space-y-4">
                <p>
                  <strong> At Nirmita Group of Companies - formally known as a Nirmita
                  International,</strong> we are committed to delivering sustainable,
                  natural, and organic products to global markets. We specialize
                  in organic fertilizers, coir-based solutions, herbal products,
                  and eco-friendly tableware, trusted for their purity, quality,
                  and consistency.{" "}
                </p>
                <p>
We have thoroughly analysed our markets to ensure that every product we export meets the highest international standards, offering certified quality and dependable supply.
                </p>

                <p>
                  <b>At Nirmita International</b>, we don't just sell products -
                  we deliver ease, trust, reliability, and peace of mind. Guided
                  by our mission to connect nature's purity with global markets,
                  we uphold responsible trade practices, reliable partnerships,
                  and consistent quality assurance through professional service
                  and timely delivery.
                </p>
                <p>
                  Our focus on quality, innovation, and sustainability drives
                  everything we do, ensuring that every partnership we build
                  contributes to a greener, healthier future.
                </p>
              </div>
            </div>

            {/* Founder Info */}
            <div className="flex flex-col items-center justify-start">
              <div className="w-[180px] h-[180px] rounded-full overflow-hidden mb-4">
                <img
                  src={founderImg}
                  // Update with the correct path
                  alt="Founder Rasika Kadam"
                  className="w-full h-full object-cover"
                />
              </div>
              <div className="bg-white px-4 py-2 rounded shadow">
                <h3 className="text-[#34302B] text-lg font-semibold">
                  Founder: Rasika Kadam
                </h3>
              </div>
            </div>
          </div>
        </section>

        {/* OUR MISSION */}
        <section className="py-16 px-4 md:px-12 lg:px-24 bg-white bg-[#fff3d6]">
          <div className="max-w-7xl mx-auto">
            <div className="flex flex-col md:flex-row-reverse gap-10 items-start">
              {/* Text */}
              <div className="md:w-1/2">
                <h2 className="bg-[#7B4B3A] text-white inline-block px-4 py-2 rounded-sm mb-4 text-lg font-semibold">
                  OUR MISSION
                </h2>
                <p className="text-[#34302B] text-lg leading-relaxed">
                  Our mission is to connect nature’s purity with global markets
                  by delivering eco-friendly, high-quality solutions that
                  support sustainable agriculture and greener living.
                </p>
                <ul className="list-disc pl-6 mt-4 text-[#34302B] text-lg space-y-2">
                  <li>Responsible trade practices</li>
                  <li>Reliable partnerships</li>
                  <li>Consistent quality assurance</li>
                  <li>Professional service & timely delivery</li>
                </ul>
              </div>

              {/* Image - Reduced size */}
              <div className="md:w-1/2">
                <img
                  src={exportImg1}
                  alt="Mission"
                  className="rounded-lg max-w-[350px] mx-auto h-auto"
                />
              </div>
            </div>
          </div>
        </section>

        {/* OUR VISION */}
        <section className="py-16 px-4 md:px-12 lg:px-24 bg-[#fff3d6]">
          <div className="max-w-7xl mx-auto">
            <div className="flex flex-col md:flex-row gap-10 items-start">
              {/* Text */}
              <div className="md:w-1/2">
                <h2 className=" bg-[#7B4B3A] text-white inline-block px-4 py-2 rounded-sm mb-4 text-lg font-semibold">
                  OUR VISION
                </h2>
                <p className="text-[#34302B] text-lg leading-relaxed">
                  We envision a world where organic and eco-friendly choices
                  replace harmful alternatives, creating:
                </p>
                <ul className="list-disc pl-6 mt-4 text-[#34302B] text-lg space-y-2">
                  <li>Healthier soils</li>
                  <li>Safer food systems</li>
                  <li>A cleaner planet for generations to come</li>
                </ul>
              </div>

              {/* Image - Reduced size */}
              <div className="md:w-1/2">
                <img
                  src={exportImg2}
                  alt="Vision"
                  className="rounded-lg max-w-[350px] mx-auto h-auto"
                />
              </div>
            </div>
          </div>
        </section>

        {/* OUR CORE VALUES */}
        <section className="py-4 mb-2 px-4 md:px-12 lg:px-24 bg-white">
          <div className="max-w-4xl mx-auto text-center">
            <h2 className="bg-[#7B4B3A] text-white inline-block px-4 py-2 rounded-sm mb-4 text-lg font-semibold">
              OUR CORE VALUES
            </h2>
            <div className="space-y-4">
              {[
                "Sustainability – Every step towards a greener tomorrow",
                "Trust – Building long-term global partnerships",
                "Quality – Delivering only the finest natural products",
                "Innovation – Constantly improving eco-friendly solutions",
                "Reliability – On-time, professional delivery",
                "Responsibility – Towards people, nature, and communities",
              ].map((value, index) => (
                <div
                  key={index}
                  className="text-left px-4 py-3 rounded bg-[#FFECE1] border border-[#E6D3C6] shadow-md 
                  hover:shadow-lg hover:scale-[1.02] transform transition-all duration-300 ease-in-out 
                  hover:bg-[#FFE6D6] cursor-pointer"
                >
                  <span className="text-green-600 mr-2">✅</span>
                  <span className="text-black font-semibold">{value}</span>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* PARTNERED WITH US */}
        <section className="py-12 px-4 md:px-12 lg:px-24 bg-[#fff3d6]">
          <div className="max-w-4xl mx-auto text-center bg-white shadow-lg py-8 px-6 rounded bg-[#FFF1E6]">
            <h2 className="bg-[#7B4B3A] text-white inline-block px-4 py-2 rounded-sm mb-4 text-lg font-semibold">
              PARTNERED WITH US
            </h2>
            <h3 className="text-[#000000] font-semibold text-2xl italic">
              "One small step from us, One big change for the earth."
            </h3>
          </div>
        </section>
      </main>
    </>
  );
}
